export const MAX_TEST_EXECUTION_NAME_LENGTH = 100;

export const TEST_EXECUTION_NAME_MAX_LENGTH_MESSAGE = 'Maximum 100 characters allowed.';

export const validateTestExecutionName = (name) => {
  if (!name?.trim()) {
    return 'Test Execution name is required';
  }
  if (name.length > MAX_TEST_EXECUTION_NAME_LENGTH) {
    return TEST_EXECUTION_NAME_MAX_LENGTH_MESSAGE;
  }
  return null;
};

export const parseTestPlanApiFieldErrors = (data) => {
  const fieldErrors = {};
  if (!data || typeof data !== 'object') {
    return fieldErrors;
  }

  if (data.name) {
    const raw = Array.isArray(data.name) ? data.name[0] : data.name;
    const text = String(raw).toLowerCase();
    if (text.includes('max_length') || text.includes('too long')) {
      fieldErrors.name = TEST_EXECUTION_NAME_MAX_LENGTH_MESSAGE;
    } else {
      fieldErrors.name = String(raw);
    }
  }

  return fieldErrors;
};
